import React from 'react';
import { makeStyles } from '@mui/styles';

export const Card = (props) => {

    const { title, total, icon, children, size } = props;
    const classes = useStyles({size});

    return (
        <div className={ classes.main }>
            <div className={ classes.containerData }>
                <span className={ classes.title }>{ title }</span>
                <span className={ classes.subTitle }>{ total }</span>
            </div>

            { children }

            <div className={ classes.icon }>
                <ion-icon style={{ fontSize: 30, color: '#fff' }} name={ icon }></ion-icon>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    main: {
        width: props => props.size,
        background: '#fff',
        height: 130,
        padding: '0px 20px 0px 20px',
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    containerData: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center'
    },
    title: {
        fontSize: 16,
        fontWeight: 600,
        color: '#9a9a98',
        marginBottom: -10,
    },
    subTitle: {
        fontSize: 40,
        fontWeight: 'bold',
        color: '#494949'
    },
    icon: {
        background: '#00365F',
        borderRadius: '50%',
        width: 60,
        height: 60,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});